import {
  GET_DATA_KARIR,
  GET_DEPARTEMENT_KARIR,
  SET_LOADING_DATA_KARIR,
  SET_LOADING_DEPARTEMENT_KARIR,
  SET_PAGINATION_DATA_KARIR,
  SET_PAGINATION_DEPARTEMENT_KARIR,
} from '../constant';

const initialState = {
  departement: [],
  loadingDepartement: false,
  departementPagination: 0,
  totalDepartement: 0,
  data: [],
  loadingData: false,
  dataPagination: 0,
  totalData: 0,
};

const karirReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING_DEPARTEMENT_KARIR: {
      return {
        ...state,
        loadingDepartement: action?.payload,
      };
    }
    case SET_PAGINATION_DEPARTEMENT_KARIR: {
      return {
        ...state,
        departementPagination: action?.payload,
      };
    }
    case GET_DEPARTEMENT_KARIR: {
      return {
        ...state,
        departement: action?.payload?.data,
        totalDepartement: action?.payload?.total,
        loadingDepartement: false,
      };
    }
    case SET_LOADING_DATA_KARIR: {
      return {
        ...state,
        loadingData: action?.payload,
      };
    }
    case SET_PAGINATION_DATA_KARIR: {
      return {
        ...state,
        dataPagination: action?.payload,
      };
    }
    case GET_DATA_KARIR: {
      return {
        ...state,
        data: action?.payload?.data || [],
        totalData: action?.payload?.total,
        loadingData: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default karirReducer;
